module.exports = __webpack_public_path__ + "static/media/warning_delete.ab66b0a8.svg";